export const GRID_EVENTS = {
	UPDATE_GRID: 'UPDATE',
	UPDATE_GRID_CELL: 'UPDATE_CELL',
	UPDATE_ROWS: 'UPDATE_ROWS',
	DELETE_ROWS: 'DELETE_ROWS',
	REFRESH_GRID: 'REFRESH',
	PURGE_GRID_ROUTE: 'PURGE_GRID_ROUTE',
	CLEAR_SELECTION: 'CLEAR_SELECTION',
	EXPORT: 'EXPORT',
	DIRTY_STATE_CHANGED: 'DIRTY_STATE_CHANGED'
};

export const PAGE_SIZE = 50;
